<template>
  <div class="home page">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-monitor-dashboard</v-icon>
      ادارة الاقسام
      <back-button />
    </h2>
    <hr class="my-5 header-divider" />

    <!-- CREATE / UPDATE FROM -->
    <record-form />

    <!-- UPDATE / NEW RECORD -->
    <filters-box @fetch="fetchRecords({ page: 1 })" />
    <div class="mb-3 mt-9 text-left">

      <v-btn
        large
        color="primary"
        elevation="0"
        @click="
          SET_FORM_RECORD({});
          SET_EDIT_MODE(false);
          SHOW_FORM();
        "
      >
        اضافة قسم جديد
        <v-icon class="mr-2">mdi-plus</v-icon>
      </v-btn>
    </div>
      <v-chip right class="mb-2" label color="secondary">
        <v-icon> mdi-account-circle-outline </v-icon> عدد الاقسام
        {{ total_sections }}</v-chip
      >
    <!-- TABLE -->
    <v-data-table
      item-key="id"
      class="elevation-1"
      :loading="table.loading"
      :headers="table.headers"
      :items="records"
      loading-text="Downloading Data"
      no-data-text="No Data"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
    >
      <template v-slot:item.checkbox="{ item }">
        <v-checkbox v-model="item.selected" ></v-checkbox>
      </template>



    <template v-slot:item.icon="{ item }">
        <img :src="item.icon" width="50px" class="mt-3 mb-2 rounded-lg" />
      </template>
      <!-- CONTROLS -->
      <template v-slot:item.controls="{ item }">
        <v-btn
          small
          icon
          color="secondary"
          class="mx-1"
          @click="
            SET_FORM_RECORD(item);
            SET_EDIT_MODE(true);
            SHOW_FORM();
          "
        >
          <v-icon>mdi-circle-edit-outline</v-icon>
        </v-btn>
      </template>
      <template v-slot:top>
        <v-toolbar flat class="d-flex justify-end">
          <v-btn color="error" class="mr-1" @click="deleteSelected">حذف المحدد</v-btn>
        </v-toolbar>
      </template>


      <template v-slot:item.blocked="{ item }">
        <v-switch
          v-if="item.active == 0"
          inset
          :input-value="false"
          @change="unblock(item)"
        ></v-switch>
        <v-switch
          v-else="item.active == 1"
          color="success"
          inset
          :input-value="true"
          @change="block(item)"
        ></v-switch>
      </template>


      <template v-slot:[`item.delete`]="{ item }">
        <v-dialog transition="dialog-top-transition" max-width="600">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="error" v-bind="attrs" v-on="on"> حذف </v-btn>
          </template>
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="red" dark>حذف القسم</v-toolbar>
              <v-card-text>
                <h4 class="my-3 red--text">هل تريد حذف هذا القسم</h4>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                    color="red"
                    dark
                    @click="deleteThisSection(item.id), (dialog.value = false)"
                >
                  حذف
                </v-btn>
                <v-btn text @click="dialog.value = false">الغاء</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </template>



    </v-data-table>

    <!-- PAGINATION -->
    <div class="text-center mt-7">
      <v-pagination
        total-visible="7"
        @input="changePage"
        :value="parseInt(getFilter.page)"
        :length="Number(totalPages)"
        circle

      ></v-pagination>
    </div>
  </div>
</template>

<script>
import RecordForm from "./RecordForm";
import {mapState, mapMutations, mapGetters, mapActions} from "vuex";
import FiltersBox from "./FiltersBox.vue";
export default {

  name: "sections",

  components: { RecordForm,  FiltersBox},

  data: function () {
    return {
      dialogDelete: false,
      // table
      table: {
        headers: [
          {
            text: "حذف",
            value: "checkbox",
          },
          {
            value: "name_ar",
            text: "الاسم بالعربية",
          },
          {
            value: "name_en",
            text: "الاسم بالانجليزية",
          },
          {
            value: "icon",
            text: "الصورة",
          },
          {
            value: "blocked",
            text: "تفعيل/تعطيل",
          },
          {
            value: "controls",
            text: "تعديل",
          },
          {
            text: "حذف",
            value: "delete",
          },
        ],
        loading: false,
      },
    };
  },

  computed: {
    ...mapState("sections", ["records", "page", "totalPages", "filters" ,"total_sections"]),
    ...mapGetters("sections",["getFilter"])
  },
  watch: {
    $route: {
      async handler(route) {
        if (!route.query.page) {
          await this.$router.replace({ query: { ...route.query, page: 1 } });
          return;
        }
        // console.log(this.getFilter, route.query)
        this.SET_FILTERS({ ...this.getFilter,...route.query });
        if(this.$route.query.flag==1){
           this.fetchRecords('');
        }
        else{
          this.fetchRecords(1);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapMutations("sections", [
      "SHOW_FORM",
      "SET_EDIT_MODE",
      "SET_FORM_RECORD",
      "SHOW_RECORD_FORM",
      "SET_FILTERS",
    ]),
    ...mapActions("sections", [
      "deleteSection","multiDeleteRecords"
    ]),
    changePage(val) {
      this.$router
        .replace({
          query: { ...this.$route.query, page: val },
        })
        .catch(() => {});
    },
    fetchRecords(active) {
      this.table.loading = true;
      this.$store
        .dispatch("sections/fetchRecords",active)
        .catch((error) => {
          this.$bus.$emit("showSnackbar", {
            text: "Error while getting Data",
            color: "accent",
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    deleteSelected() {

      const selectedRecords = this.records.filter((item) => item.selected);
      const Ids = selectedRecords.map((item) => item.id);

      if (Ids.length > 0) {
        this.multiDeleteRecords(Ids).then(() => {
          this.fetchRecords();
        });
      } else {
        // You can use a snackbar or any other UI component for this
        console.log('No Sections selected for deletion.');
      }
    },

    async unblock(selectedRecord) {
      this.table.loading = true;

      await this.$store
        .dispatch("sections/unblock", { record: { ...selectedRecord } })
        .then(() => {
          this.$bus.$emit("showSnackbar", {
            text: `   تم فك حظر  ${selectedRecord.name_ar}`,
            color: "success",
          });
          this.fetchRecords();
        })
        .catch((error) => {
          this.$bus.$emit("showSnackbar", {
            text: "Error while unblocking Admin  ",
            color: "red darken-3",
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    async block(selectedRecord) {
      this.table.loading = true;

      await this.$store
        .dispatch("sections/block", { record: { ...selectedRecord } })
        .then(() => {
          this.$bus.$emit("showSnackbar", {
            text: ` تم حظر   ${selectedRecord.name_ar}`,
            color: "warning",
          });
          this.fetchRecords();
        })
        .catch((error) => {
          this.$bus.$emit("showSnackbar", {
            text: " Error while blocking Admin",
            color: "red darken-3",
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    deleteThisSection(id) {
      this.deleteSection(id).then(() => {
        this.fetchRecords();
      });
    },
  },
};
</script>
